import { SharedService } from './../../utils/shared.service';
import { Component, OnInit, Input,ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { MasterService } from '../../masters/master.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { EmployeeModel } from './contact.model';
import * as CommonConstants from '../../utils/common.constants';
import { ToastrService } from 'ngx-toastr';
import { AddDepartmentComponent } from '../add-department/add-department.component';
import { CustomDatePipe } from '../../utils/custom.datepipe';
import * as moment from 'moment';
@Component({
  selector: 'app-add-contact',
  templateUrl: './add-contact.component.html',
  styleUrls: ['./add-contact.component.scss']
})
export class AddContactComponent implements OnInit {
  contact: string;
  contactList: EmployeeModel[];
  employeeList: any = [];
  gender:any[];
  civility: any=[];
  partnerDepartment=[];
  form: FormGroup;
  employee: EmployeeModel = new EmployeeModel();
  @Input() partnerId: number;
  @Input() partnerType: number;
  submitted = false;
  columnDefs:any[];
  toggleDiv = true;
  // maxDate: any = new Date(new Date().getTime());
  // minDate: any;

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private masterService: MasterService, config: NgbModalConfig, private modalService: NgbModal,
    private sharedService: SharedService, private toastrService:ToastrService,private customDate:DatePipe) {
    //this.contactList = [];
    this.employee.civilCode = this.employee.gendeCode = this.employee.deptmId = null;
    this.getFromGroup();
    this.employee["staRecCode"]=true;
    /*  for (let i = 0; i < 10; i++) {
         this.contactList.push({label: 'contact ' + i, value: 'contact ' + i});
     } */

     this.columnDefs = [
      { headerName: 'Last Name', field: 'persoVaLastnameEn' },
      { headerName: 'First Name', field: 'persoVaFirstnameEn'},
      { headerName: 'Mobile Phone', field: 'persoVaMobilePhone1' },
      { headerName: 'Email', field: 'persoVaEmail'},
      { headerName: 'Department', field: 'deptmId'}       
    ];  
     
  }

  ngOnInit() {
   this.loadMasters();
  }
  loadDepartments(){
  }
  
  contactAddModal(addContact) {
    this.partnerDepartment=this.sharedService.getOrganismDepartment();
    this.submitted = false;
    this.employee = new EmployeeModel();
    this.getFromGroup();
    this.employee["staRecCode"]=true;
    this.modalService.open(addContact, { size: 'xl', container: '.page-content' });

  }
  get f() { return this.form.controls; }

  private getFromGroup() {
    this.form = this.formBuilder.group({
      'empyeeId': new FormControl(),
      'persoVaLastnameEn': new FormControl('', Validators.compose([Validators.required, Validators.maxLength(20)])),
      'civilCode': new FormControl(''),
      'persoVaFirstnameEn': new FormControl('', Validators.compose([Validators.required, Validators.maxLength(20)])),
      'gendeCode': new FormControl(''),
      'dateOfBirth': new FormControl(),
      'deptmId': new FormControl(),
      'persoVaWorkPhone': new FormControl(),
      'persoVaWorkFax': new FormControl(),
      'persoVaMobilePhone1': new FormControl(),
      'persoVaMobilePhone2': new FormControl(),
      'persoVaEmail': ['', Validators.email],
      'empyeeVaFunction': new FormControl(),
      'persoDtBirthDate': new FormControl(),
      'joinigndate': new FormControl(),
      'employeeid': new FormControl(),
      'persoVaThirdName': new FormControl(),
      'persoVaSecondName': new FormControl(),
      'maritalname': new FormControl(),
      'persoVaEmail2': ['', Validators.email],
      'staRecCode': [true]
    })
  }

  editContact(employee, addContact) {
    this.partnerDepartment=this.sharedService.getOrganismDepartment();
    this.modalService.open(addContact, { size: 'xl', container: '.page-content' });
    //this.employee = JSON.parse(JSON.stringify(employee.data));
    //this.employee["staRecCode"]=this.employee["staRecCode"] ==='A' ? true : false;
    this.form.patchValue({
      "empyeeId": employee.data["empyeeId"],
      "persoVaLastnameEn": employee.data["persoVaLastnameEn"],
      "civilCode": +employee.data["civilCode"],
      "persoVaFirstnameEn": employee.data["persoVaFirstnameEn"],
      "gendeCode": +employee.data["gendeCode"],
      'deptmId': +employee.data["deptmId"],
      'persoVaWorkPhone': employee.data["persoVaWorkPhone"],
      'persoVaWorkFax': employee.data["persoVaWorkFax"],
      'persoVaMobilePhone1': employee.data["persoVaMobilePhone1"],
      'persoVaMobilePhone2': employee.data["persoVaMobilePhone2"],
      'persoVaEmail': employee.data["persoVaEmail"],
      'empyeeVaFunction': employee.data["empyeeVaFunction"],
      'persoDtBirthDate': employee.data["persoDtBirthDate"],
      'joinigndate': employee.data["joinigndate"],
      'employeeid': employee.data["employeeid"],
      'persoVaThirdName': employee.data["persoVaThirdName"],
      'persoVaSecondName': employee.data["persoVaSecondName"],
      'maritalname': employee.data["maritalname"],
      'persoVaEmail2': employee.data["persoVaEmail2"],
      'staRecCode': employee.data["staRecCode"]==='A' ? true : false,
    });
  }
  loadMasters() {
    this.masterService.getCivility().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.civility = response['result'];
      }
    });
    this.masterService.getGender().subscribe(response => {
      if (response && response['result']) {
        this.gender = response['result'];
      }
    })
  }
  /* getGender() {
    this.masterService.getCountry().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.gender = response['result'];
      }
    });
  } */
  saveEmployee() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    if(this.form.value.persoDtBirthDate!=null){
      this.form.patchValue({persoDtBirthDate:moment(this.form.value.persoDtBirthDate,"DD-MM-YYYY").format("DD-MM-YYYY")})
    }
      if(this.form.value.joinigndate && this.partnerType!=10){
      this.form.patchValue({joinigndate:moment(this.form.value.joinigndate,"DD-MM-YYYY").format("DD-MM-YYYY")})
    }
    let jsonData=this.form.value;
    jsonData["partnerId"]=this.partnerId;
    jsonData["partnerType"]=this.partnerType;
    jsonData["staRecCode"]=jsonData["staRecCode"] ? 'A' :'I';
    let res = this.http.post(CommonConstants.SAVE_CONTACT, jsonData)
      .subscribe(response => {
        if (response['code'] == 0) {
          this.toggleDiv = true;
          this.toastrService.success(response['message'], 'Success');
          jsonData["empyeeId"] = response['result'];
          this.employeeList = this.sharedService.updateDuplicateRecord(jsonData["empyeeId"], this.employeeList, "empyeeId", jsonData);
          this.modalService.dismissAll('#addContact');
        
        } else {
          this.toastrService.error(response['message'], 'Error');
        }

      });
  }
  toggleContent(){
    this.toggleDiv = !this.toggleDiv;
  }


}
